<template>
  <div class="mb-6">

    <div class="columns is-multiline">
      <div class="column is-12-mobile is-2-tablet">
        <InputSelect
          name="Occupante"
          v-model="filters.occupant"
          :options="clients"
          :loading="waitClients"
          :disabled="waitClients"
          id="_id"
          track-by="_id"
          :custom-label="$clientName"
          @select="filterOccupant"
          @remove="filterOccupant(false)"
        />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputSelect
          name="Proprietario"
          v-model="filters.client"
          :options="clients"
          :loading="waitClients"
          :disabled="waitClients"
          id="_id"
          track-by="_id"
          :custom-label="$clientName"
          @select="filterClient"
          @remove="filterClient(false)"
        />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputText :hasIconSearch="true" name="Luogo" v-model="filters.place" @input="onFilterInput" />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputText :hasIconSearch="true" name="Modello/Marca" v-model="filters.modelBrand" @input="onFilterInput" />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputText :hasIconSearch="true" name="Codice" v-model="filters.code" @input="onFilterInput" />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputText :hasIconSearch="true" name="Targa" v-model="filters.plate" @input="onFilterInput" />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputText :hasIconSearch="true" name="Installatore" v-model="filters.installer" @input="onFilterInput" />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputText :hasIconSearch="true" name="Note" v-model="filters.notes" @input="onFilterInput" />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputSelect
          name="Archiviato"
          v-model="filters.archived"
          @select="onFilterInput"
          @remove="onFilterInput"
          :options="[{'label': 'Sì', value: true}, {'label': 'No', value: false}]"
          id="value"
          track-by="value"
          label="label"
          :allowEmpty="true"
        />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputSelect
          name="Dismessi/Sostituiti"
          v-model="filters.dismissed"
          @select="onFilterInput"
          @remove="onFilterInput"
          :options="[{'label': 'Sì', value: true}, {'label': 'No', value: false}]"
          id="value"
          track-by="value"
          label="label"
          :allowEmpty="true"
        />
      </div>

      <!--<div class="column is-12-mobile is-1-tablet">
        <div class="field">
          <label class="label">Archiviati</label>
          <div class="control">
            <input type="checkbox" v-model="filters.archived" @change="getImplants()">
          </div>
        </div>
      </div>-->
      <!--<div class="column is-12-mobile is-3-tablet">
        <div class="field">
          <label class="label">Ordina per</label>
          <div class="control">
            <multiselect v-model="filters.order" @select="filterOrder" @remove="filterOrder(false)" :options="orders" placeholder="Ordina per" track-by="value" label="text" :allow-empty="false"></multiselect>
          </div>
        </div>
      </div>-->
      <div class="column is-12-mobile is-4-tablet">
        <label class="label">&nbsp;</label>
        <div class="buttons is-flex">
          <button class="button" @click="resetFilters()"><font-awesome-icon icon="filter-circle-xmark" />Reset</button>
          <router-link to="/impianti/new" class="button is-primary is-hidden-touch" @click="resetFilters()"><font-awesome-icon icon="plus" />Aggiungi</router-link>
        </div>
      </div>
    </div>

    <!--<div class="columns is-multiline">
      <div class="column is-12-mobile is-1-tablet">
        <label class="label">&nbsp;</label>
        <button class="button is-info" @click="openSelected = true" :disabled="selected.length === 0">Modifica</button>
      </div>
    </div>-->

    <div class="b-table has-pagination" :class="{'is-loading': loading}">
      <div class="table-wrapper has-mobile-cards">
        <table class="table is-fullwidth is-striped is-hoverable">
          <thead>
          <tr>
            <!--<th style="width: 14px;"></th>-->
            <th><div>Occupante</div><div><small class="has-text-grey is-abbr-like">Proprietario</small></div></th>
            <th>Luogo</th>
            <th><div>Modello</div><div><small class="has-text-grey is-abbr-like">Marca</small></div></th>
            <th>Codice</th>
            <th>Targa</th>
            <th>Installatore</th>
            <th>Data scadenza</th>
            <th>Note</th>
            <th style="min-width: 100px;"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(implant, index) in implants" :key="index" :class="{'implant-row-archived': implant.archived}">
            <!--<td>
              <label class="checkbox">
                <input type="checkbox" v-model="implant.selected">
              </label>
            </td>-->
            <td data-label="Occupante">
              <router-link v-if="implant.occupant" :to="'/clienti/' + implant.occupant._id">
                <ClientHeading :client="implant.occupant" />
              </router-link>
              <router-link v-if="implant.client" :to="'/clienti/' + implant.client._id">
                <ClientHeading :client="implant.client" :owner="true" />
              </router-link>
            </td>
            <td data-label="Luogo">
              <router-link v-if="implant.place_occupant" :to="'/luoghi/' + implant.place_occupant._id">
                <AddressDisplay :value="implant.place_occupant" />
              </router-link>
            </td>
            <td data-label="Modello">
              <div v-for="(combo, index) in getBrandModels(implant)" :key="index">
                <div v-if="combo.model">{{combo.model}}</div>
                <div v-if="combo.brand"><small class="has-text-grey is-abbr-like" :title="combo.brand">{{combo.brand}}</small></div>
              </div>
              <div class="tags" v-if="calcTypes(implant)?.length">
                <span class="tag is-dark" v-for="(type, index) in calcTypes(implant)" :key="index">{{ type }}</span>
              </div>
            </td>
            <td data-label="Codice">
              <div class="field is-grouped is-grouped-multiline" v-if="implant.codes?.length">
                <div class="control" v-for="(code, index) in implant.codes" :key="index">
                  <span class="tag is-primary">{{ code }}</span>
                </div>
              </div>
            </td>
            <td data-label="Targa">
              {{implant.plate}}
            </td>
            <td data-label="Installatore">
              <div v-for="(installer, index) in getInstallers(implant)" :key="index">
                {{installer}}
              </div>
            </td>
            <td data-label="Data scadenza" style="flex-wrap: wrap;">
              <div style="width: 100%;">
                <div class="tags has-addons" v-for="(revision, index) in implant.revisions.filter(revision => revision.expire)" :key="index">
                  <span class="tag is-dark" v-if="revision.type">{{revision.type}}</span>
                  <span class="tag is-info">{{new Date(revision.expire).toDisplay()}}</span>
                </div>
              </div>
            </td>
            <td data-label="Note">
              <div class="buttons">
                <InfoButton :text="implant.notes" />
                <button v-if="hasArchivedGenerators(implant)" class="button is-dark is-small" @click="showArchivedInfo(implant)" title="Generatori dismessi/sostituiti">
                  Dismessi/Sostituiti
                </button>
              </div>
            </td>
            <td class="is-actions-cell is-justify-content-flex-end">
              <div class="buttons is-right">
                <button v-if="!implant.archived" class="button is-secondary" @click="archive(implant, true)" title="Archivia" :class="[{'is-loading': implant.waitArchive}]" :disabled="implant.waitArchive">
                  <span class="icon"><font-awesome-icon icon="lock" /></span>
                </button>
                <button v-if="implant.archived" class="button is-secondary" @click="archive(implant, false)" title="Ripristina" :class="[{'is-loading': implant.waitArchive}]" :disabled="implant.waitArchive">
                  <span class="icon"><font-awesome-icon icon="lock-open" /></span>
                </button>
                <router-link :to="'/impianti/' + implant._id" class="button is-warning" title="Modifica" :disabled="implant.waitDelete">
                  <span class="icon"><font-awesome-icon icon="pen" /></span>
                </router-link>
                <button class="button is-danger" @click="deleteImplant(implant)" title="Elimina" :class="[{'is-loading': implant.waitDelete}]" :disabled="implant.waitDelete">
                  <span class="icon"><font-awesome-icon icon="trash-can" /></span>
                </button>
              </div>
            </td>
          </tr>
          <tr v-if="implants.length === 0">
            <td colspan="100" class="has-text-centered has-text-grey">
              <i>Nessun risultato</i>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <Pagination :pagination="pagination" @change="getImplants($event)" />
    </div>

    <router-link to="/impianti/new" class="button is-floating is-primary is-hidden-desktop" title="Nuovo">
      <span class="icon">
        <font-awesome-icon icon="plus" />
      </span>
    </router-link>

    <Modal :title="'Modifica scadenza'" :openModal="openSelected" @close="openSelected = false" @success="changeSelected()" :loading="waitSaveSelected">
      <div class="field">
        <label class="label">Nuova scadenza</label>
        <div class="control">
          <input class="input" type="date" placeholder="Nuova scadenza" v-model="openSelectedNewDate" />
        </div>
      </div>
    </Modal>

    <Modal :title="'Generatori dismessi/sostituiti'" :openModal="openArchivedModal" @close="openArchivedModal = false" :noAction="true" style="width: 90%;">
      <div class="table-wrapper has-mobile-cards">
        <table class="table is-fullwidth is-striped">
          <thead>
            <tr>
              <th>Marca</th>
              <th>Modello</th>
              <th>Matricola</th>
              <th>Installatore</th>
              <th>Data installazione</th>
              <th>Data dismissione</th>
              <th>Stato</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(generator, index) in getArchivedGenerators(selectedImplant)" :key="index">
              <td data-label="Marca">{{generator.brand}}</td>
              <td data-label="Modello">{{generator.model}}</td>
              <td data-label="Matricola">{{generator.registration}}</td>
              <td data-label="Installatore">{{generator.installer}}</td>
              <td data-label="Data installazione">{{generator.date_install ? new Date(generator.date_install).toDisplay() : ''}}</td>
              <td data-label="Data dismissione">{{generator.date_dismission ? new Date(generator.date_dismission).toDisplay() : ''}}</td>
              <td data-label="Stato">{{ generator.replaced ? 'Sostituito' : 'Dismesso' }}</td>
            </tr>
            <tr v-if="getArchivedGenerators(selectedImplant).length === 0">
              <td colspan="7" class="has-text-centered has-text-grey">
                <i>Nessun generatore dismesso/sostituito</i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </Modal>

  </div>
</template>

<script>
import utils from '../utils.js'
import AddressDisplay from '../components/AddressDisplay.vue'

export default {
  components: {
    AddressDisplay
  },

  data() {
    return {
      filters: this.$store.state.filters.implant,

      clients: [],
      cities: [],

      orders: [
        {
          text: 'Data scadenza ASC',
          value: 'revisions.expire_asc',
        }
      ],

      implants: [],

      pagination:{
        total: false,
        selected: false
      },

      loading: true,
      waitClients: true,
      waitCities: true,

      openSelected: false,
      openSelectedNewDate: '',
      waitSaveSelected: false,

      openArchivedModal: false,
      selectedImplant: null
    }
  },

  /*computed: {
    selected() {
      const result = this.implants.filter(implant => {
        if (implant.selected) {
          return true
        }
      })
      return result
    }
  },*/

  methods: {
    resetFilters() {
      this.filters = {}

      this.getImplants()
    },

    filterClient(selected) {
      this.filters.client = selected
      this.getImplants()
    },

    filterOccupant(selected) {
      this.filters.occupant = selected
      this.getImplants()
    },

    /*filterOrder(selected) {
      this.filters.order = selected
      this.getImplants()
    },*/

    getImplants(args = {page: 1, size: 30, scroll: 0}) {
      const self = this

      this.loading = true

      this.$store.commit('setFilter', {name: 'implant', value: this.filters})
      this.$store.commit('setPage', {name: 'implant', value: {number: args.page, size: args.size}})

      const clientId = this.filters.client ? this.filters.client._id : null
      const occupantId = this.filters.occupant ? this.filters.occupant._id : null
      const archived = this.filters.archived ? this.filters.archived.value : null
      const dismissed = this.filters.dismissed ? this.filters.dismissed.value : null

      this.$http.get('/implant', { params: {
        page: args.page,
        size: args.size,
        client: clientId,
        occupant: occupantId,
        place: this.filters.place,
        modelBrand: this.filters.modelBrand,
        code: this.filters.code,
        plate: this.filters.plate,
        notes: this.filters.notes,
        installer: this.filters.installer,
        archived,
        dismissed
      } }).then(response => {
        if (response && response.data) {
          this.implants = response.data.records
          this.pagination = {
            total: response.data.totalRecords,
            pages: response.data.totalPages,
            selected: response.data.currentPage
          }

          if (args.scroll) {
            self.$nextTick(() => {
              window.scroll(0, args.scroll)
            })
          }
        }

        this.loading = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.loading = false
      })
    },

    deleteImplant(implant) {
      if (confirm('Eliminare?')) {
        const self = this
        implant.waitDelete = true

        this.$http.delete('/implant/' + implant._id)
        .then(function (response) {
          self.getImplants({page: self.$store.state.pages.implant.number, size: self.$store.state.pages.implant.size})
        })
        .catch(function (error) {
          console.log(error)
          alert('Errore')
          implant.waitDelete = false
        })
      }
    },

    changeSelected() {
      const self = this

      if (!self.openSelectedNewDate) {
        alert('Devi inserire una data!')
        return
      }

      this.waitSaveSelected = true

      let ids = []
      self.selected.forEach(element => {
        ids.push(element._id)
      })

      this.$http.post('/implant/multiple-edit', { ids: ids, newDate: self.openSelectedNewDate }).then(response => {
        self.getImplants()

        self.openSelected = false
        self.waitSaveSelected = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.openSelected = false
        self.waitSaveSelected = false
      })
    },

    getBrandModels(implant) {
      const generators = utils.getGenerators(implant)

      const combos = []
      generators.forEach((gen) => {
        combos.push({
          brand: gen.brand,
          model: gen.model
        })
      })

      return combos
    },

    archive(implant, value) {
      const self = this
      implant.waitArchive = true

      this.$http.put('/implant/' + implant._id, {archived: value})
      .then(function (response) {
        self.getImplants()
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        implant.waitArchive = false
      })
    },

    calcTypes(implant, implantCode, implantGenerators) {
      return utils.calcTypes(implant, implantCode, implantGenerators)
    },

    getInstallers(implant) {
      const generators = utils.getGenerators(implant)
      const installers = [...new Set(generators.map(gen => gen.installer).filter(Boolean))]
      return installers
    },

    hasArchivedGenerators(implant) {
      const allGenerators = utils.getGenerators(implant, true) // true per includere anche quelli archiviati
      return allGenerators.some(gen => gen.archived)
    },

    showArchivedInfo(implant) {
      this.selectedImplant = implant
      this.openArchivedModal = true
    },

    getArchivedGenerators(implant) {
      if (!implant) return []
      const allGenerators = utils.getGenerators(implant, true)
      return allGenerators.filter(gen => gen.archived)
    }
  },

  mounted() {
    const self = this

    const clientId = this.$route.query.client ? this.$route.query.client : false

    /*if (!clientId) {
      this.getImplants()
    }*/

    this.$http.get('/client/filter')
      .then(function (response) {
        self.clients = response.data

        if (clientId) {
          const foundClient = self.clients.find(client => client._id === clientId)
          if (foundClient) {
            self.filters.client = foundClient
          }

          //self.getImplants()
        }

        self.waitClients = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })

    this.$http.get('/place/cities/filter')
      .then(function (response) {
        self.cities = response.data

        self.waitCities = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })

    self.getImplants({page: this.$store.state.pages.implant.number, size: this.$store.state.pages.implant.size, scroll: this.$store.state.pages.implant.scroll})
  },

  created() {
    this.onFilterInput = this.$debounce(() => this.getImplants(), 500)
  },

  beforeUnmount() {
    const scroll = window.top.scrollY
    let page = Object.assign({}, this.$store.state.pages.implant)
    page.scroll = scroll
    this.$store.commit('setPage', {name: 'implant', value: page})
  }
}
</script>

<style scoped>
.implant-row-archived > td {
  background-color: #ffe5e5 !important;
}
</style>